export const SET_AMOUNT_SLIDER = 'SET_AMOUNT_SLIDER';
export const SET_PAYMENT_SLIDER = 'SET_PAYMENT_SLIDER';
export const SET_TABLE = 'SET_TABLE';
export const SET_TABLE_RECAP = 'SET_TABLE_RECAP';
export const SET_CURRENT_SIMULATION = 'SET_CURRENT_SIMULATION';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_MODAL = 'SET_MODAL';
export const SET_SKIP_SIMULATION = 'SET_SKIP_SIMULATION';
export const SET_SKIP_RECAP = 'SET_SKIP_RECAP';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_PASSED_DATA = 'SET_PASSED_DATA';
export const SET_INTERNAL_THEME = 'SET_INTERNAL_THEME';
export const SET_IS_SPEED_APP = 'SET_IS_SPEED_APP';
export const SET_LOADER = 'SET_LOADER';
